<template>
	<header id="header">
		<div class="inner">

			<!-- Logo -->
			<router-link v-if="title" to="/" class="logo">
				<span class="symbol"><img src="/images/heart.png" alt="Round Table Deutschland" class="rt_logo"/></span>
				<!--
				<span class="symbol"><img src="/images/logos/rt.png" alt="Round Table Deutschland" class="rt_logo"/></span>
				<span class="symbol"><img src="/images/logos/ot.png" alt="Old Tablers Deutschland" class="rt_logo"/></span>
				<span class="symbol"><img src="/images/logos/lc.png" alt="Ladies Circle Deutschland" class="rt_logo"/></span>
				<span class="symbol"><img src="/images/logos/tc.png" alt="Tangent Club Deutschland" class="rt_logo"/></span>
				-->
				<span class="title mt-05">{{title}}</span>
			</router-link>

			<!-- Nav -->
			<nav>
			<ul>
				<li><a href="#menu">Menu</a></li>
			</ul>
			</nav>

		</div>
	</header>    
</template>

<script>

export default {
  name: 'RTHeader',
  props:{
      title:{
          type:String
      }
  },
  components:{
  },
  data: function() {
    return {
    };
  },
  methods:{
  }
};
</script>

<style scoped type='text/css'>

</style>